import { classNames } from "@/utility/jsx";
import type { HTMLAttributes, PropsWithChildren } from "react";
import style from "./style.module.scss";

type RoundedButtonProps = {
  size?: "small" | "medium" | "large";
  selected?: boolean;
  active?: boolean;
};

export const RoundedButton = ({
  children,
  size = "medium",
  selected = false,
  active = false,
  ...props
}: PropsWithChildren<HTMLAttributes<HTMLButtonElement>> & RoundedButtonProps) => (
  <button
    type="button"
    {...props}
    className={classNames(
      style["rounded-button"],
      style[`rounded-button--${size}`],
      active ? style.active : "",
      selected ? style.selected : "",
      props.className,
    )}
  >
    {children}
  </button>
);
